import { getFetch } from '../fetch';

import { apiConfig } from '../config';

export function getProblemsInCourse(courseId: any, problemIds: any) {
    const { apiGetProblemsInCourse } = apiConfig.getStaticUrls();

    return getFetch(apiGetProblemsInCourse, { courseId, problems: problemIds.join(',') });
}
